import {
    VALUE_CODES,
    VALUE_LABELS,
    ValueCode,
    ValueScoreViewModel,
    ServiceScoreViewModel
} from "../models/OverviewDashboard";

export const calculatePoleScores = (
    services: ServiceScoreViewModel[]
): Record<ValueCode, ValueScoreViewModel> => {
    return VALUE_CODES.reduce((result, code) => {
        const availableScores = services
            .map((service) => service.values[code].score)
            .filter((score): score is number => typeof score === "number" && Number.isFinite(score));

        if (availableScores.length === 0) {
            result[code] = {
                code,
                label: VALUE_LABELS[code],
                status: "no-data"
            };
            return result;
        }

        const score = availableScores.reduce((sum, value) => sum + value, 0) /
            availableScores.length;

        result[code] = {
            code,
            label: VALUE_LABELS[code],
            score: Math.round(score * 10) / 10,
            percentage: Math.round(score * 10),
            status: "available"
        };

        return result;
    }, {} as Record<ValueCode, ValueScoreViewModel>);
};
